module.exports = __webpack_public_path__ + "img/brgzhewm.1bc5b55b.jpg";